import { useAppContext } from '../Context/AppContext';

export const useFeature = (feature) => {
	const { state } = useAppContext();
	return Boolean(state.user.organization?.features?.[feature]);
};

export const useDefaultItemizedBids = () => {
	const { state } = useAppContext();
	return Boolean(state.user.organization?.default_itemized_bids);
};

export const useSubscriptionPlan = () => {
	const { state } = useAppContext();
	return state.user.organization?.subscription_plan ?? 'basic';
};
